// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2862236d","453":"9e487a32","455":"4f181fd0","977":"e7fbadbf"}[chunkId] + ".chunk.js";
};